const contador = 1;

export default contador;
